import { lazy } from "react";
import { RouteType, type } from "../components/Router/Router";
import AdminLayout from "../layouts/admin/admin.layout";
import AppLayout from "../layouts/app/app.layout";
import ProductLayout from "layouts/products/products.layout";
const OrdersPage = lazy(() => import("../pages/orders"));
const StatsSelectionPage = lazy(() => import("../pages/stats"));
const TypeSelectionPage = lazy(
  () => import("../pages/stats/pages/TypeSelectionPage"),
);
const DataVisualizationPage = lazy(
  () => import("../pages/stats/pages/DataVisualizationPage"),
);
const TicketsPage = lazy(() => import("../pages/tickets"));
const TicketForm = lazy(
  () => import("../pages/tickets/components/ticketDetails"),
);
const EstendoTicketForm = lazy(
  () => import("../pages/estendoTickets/components/estendoTicketDetails"),
);
const ProductSelectionPage = lazy(
  () => import("../pages/products/pages/ProductSelectionPage"),
);
const ModelSelectionPage = lazy(
  () => import("../pages/products/pages/ModelSelectionPage"),
);
const FamilySelectionPage = lazy(
  () => import("../pages/products/pages/FamilySelectionPage"),
);
const AccessoriesAndServicesPage = lazy(
  () => import("../pages/products/pages/AccessoriesAndServicesPage"),
);
const VirtualLandStoriesPage = lazy(
  () => import("../pages/products/pages/VirtualLandStoriesPage"),
);
const AddPhysicalProductPage = lazy(
  () => import("../pages/products/pages/AddPhysicalProductPage"),
);
const RecapCartPage = lazy(
  () => import("../pages/products/pages/RecapCartPage"),
);
const CustomerInfoPage = lazy(
  () => import("../pages/products/pages/CustomerInfoPage"),
);
const ShippingManagementPage = lazy(
  () => import("../pages/products/pages/ShippingManagementPage"),
);

const GeneralError = lazy(() => import("../helpers/ErrorBoundary"));
const Login = lazy(() => import("../pages/auth/login"));
const CustomerOnBoarding = lazy(() => import("../pages/customerOnBoarding"));
const ChooseCompanyPage = lazy(() => import("../pages/auth/chooseCompany"));
const PasswordForgotPage = lazy(() => import("../pages/auth/forgotPassword"));
const PasswordResetPage = lazy(() => import("../pages/auth/resetPassword"));
const Forbidden = lazy(() => import("../pages/auth/forbidden"));
const CustomersPage = lazy(() => import("../pages/customers"));
const CustomerDetailPage = lazy(
  () => import("../pages/customers/components/detail"),
);
const ContractsPage = lazy(() => import("../pages/contracts"));
const ContractsDetailPage = lazy(
  () => import("../pages/contracts/components/contractDetail"),
);
const EmailsPage = lazy(() => import("../pages/emails"));
const ExcelImportPage = lazy(() => import("../pages/import-excel"));
const UsersPage = lazy(() => import("../pages/users"));
const AgenciesPage = lazy(() => import("../pages/agencies"));
const FamiliesAgenciesPage = lazy(() => import("../pages/familiesAgencies"));
const FamiliesPage = lazy(() => import("../pages/families"));
const ModelsPage = lazy(() => import("../pages/models"));
const ProductsManagementPage = lazy(() => import("../pages/products-management"));
const ProductMarginsPage = lazy(() => import("../pages/product-margins"));
const ProductServiceCostsPage = lazy(() => import("../pages/product-service-costs"));
const ServicesPage = lazy(() => import("../pages/services"));
const RatesPage = lazy(() => import("../pages/rates"));
const CreditProvidersPage = lazy(() => import("../pages/credit-providers"));
const PersonOnBoarding = lazy(() => import("../pages/customerOnBoardingPrivacy"));
const CommissionsPage = lazy(() => import("../pages/commissions"));
const AliquoteContributivePage = lazy(() => import("../pages/aliquote-contributive"));
const RegoleProvvigionaliPage = lazy(() => import("../pages/regole-provvigionali"));

export const routes: RouteType[] = [
  {
    id: "login",
    path: "/login",
    titleLocalizationKey: "pages.login.title",
    component: Login,
    layout: AppLayout,
    type: type.AUTHENTICATION,
  },
  {
    id: "onBoardingCustomerUser",
    path: "/on-boarding",
    titleLocalizationKey: "pages.obBoarding.title",
    component: CustomerOnBoarding,
    layout: AppLayout,
    type: type.AUTHENTICATION,
  },
  {
    id: "onBoardingCustomerUser",
    path: "/on-boarding-privacy",
    titleLocalizationKey: "pages.obBoarding.title",
    component: PersonOnBoarding,
    layout: AppLayout,
    type: type.AUTHENTICATION,
  },
  {
    id: "onBoardingCustomerUserAgency",
    path: "/on-boarding/:agency",
    titleLocalizationKey: "pages.obBoarding.title",
    component: CustomerOnBoarding,
    layout: AppLayout,
    type: type.AUTHENTICATION,
  },
  {
    id: "chooseCompany",
    path: "/choose-company",
    titleLocalizationKey: "pages.login.title",
    component: ChooseCompanyPage,
    layout: AppLayout,
    type: type.SECURED,
  },
  {
    id: "GeneralError",
    path: "/GeneralError",
    titleLocalizationKey: "general_error.title",
    component: GeneralError,
    // type: type.AUTHENTICATION,
    type: type.PUBLIC,
  },
  {
    id: "passwordForgot",
    path: "/forgot-password",
    titleLocalizationKey: "pages.login.title",
    component: PasswordForgotPage,
    layout: AppLayout,
    // redirectTo: "/",
    type: type.AUTHENTICATION,
  },
  {
    id: "passwordReset",
    path: "/recovery-password",
    titleLocalizationKey: "pages.reset_password.title",
    component: PasswordResetPage,
    layout: AppLayout,
    // redirectTo: "/",
    // type: type.AUTHENTICATION,
    type: type.AUTHENTICATION,
  },
  {
    id: "homepage",
    titleLocalizationKey: "pages.home.title",
    path: "/",
    // additionalPaths: ["/products"],
    redirectTo: "/products",
  },
  {
    id: "products",
    titleLocalizationKey: "pages.products.title",
    path: "/products",
    fallbackPath: "/customers",
    component: FamilySelectionPage,
    showInMenu: true,
    layout: ProductLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "products",
  },
  {
    id: "cart",
    titleLocalizationKey: "pages.cart.title",
    path: "/cart/accessories-and-services",
    component: AccessoriesAndServicesPage,
    showInMenu: false,
    layout: ProductLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "products",
  },
  {
    id: "cart",
    titleLocalizationKey: "pages.cart.title",
    path: "/cart/virtual-land-stories",
    component: VirtualLandStoriesPage,
    showInMenu: false,
    layout: ProductLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "products",
  },
  {
    id: "cart",
    titleLocalizationKey: "pages.cart.title",
    path: "/cart/recap",
    component: RecapCartPage,
    showInMenu: false,
    layout: ProductLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "products",
  },
  {
    id: "cart",
    titleLocalizationKey: "pages.cart.title",
    path: "/cart/customer-info",
    component: CustomerInfoPage,
    showInMenu: false,
    layout: ProductLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "products",
  },
  {
    id: "cart",
    titleLocalizationKey: "pages.cart.title",
    path: "/cart/shipping-management",
    component: ShippingManagementPage,
    showInMenu: false,
    layout: ProductLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "products",
  },
  {
    id: "AddPhysicalProductPage",
    titleLocalizationKey: "pages.products.title",
    path: "/products/add-physical-product",
    component: AddPhysicalProductPage,
    showInMenu: false,
    layout: ProductLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "products",
  },
  {
    id: "ModelSelectionPage",
    titleLocalizationKey: "pages.products.title",
    path: "/products/:familyId",
    component: ModelSelectionPage,
    showInMenu: false,
    layout: ProductLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "products",
  },
  {
    id: "ProductSelectionPage",
    titleLocalizationKey: "pages.products.title",
    path: "/products/:familyId/:modelId",
    component: ProductSelectionPage,
    showInMenu: false,
    layout: ProductLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "products",
  },
  {
    id: "customers",
    titleLocalizationKey: "pages.customers.title",
    path: "/customers",
    component: CustomersPage,
    showInMenu: true,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "customers",
  },
  {
    id: "customerDetail",
    titleLocalizationKey: "pages.customers.title",
    path: "/customers/:customerId",
    component: CustomerDetailPage,
    showInMenu: false,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "customers",
  },
  // {
  //   id: "contractDetail",
  //   titleLocalizationKey: "pages.customers.title",
  //   path: "/customers/:customerId/:contractId",
  //   component: ContractDetailPage,
  //   showInMenu: false,
  //   layout: AdminLayout,
  //   type: type.SECURED,
  //   layoutOptions: {
  //     hideOnBack: false,
  //   },
  //   section: "customers",
  // },
  {
    id: "contracts",
    titleLocalizationKey: "pages.contracts.title",
    path: "/contracts",
    component: ContractsPage,
    showInMenu: true,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "contracts",
  },
  {
    id: "emails",
    titleLocalizationKey: "pages.emails.title",
    path: "/emails",
    component: EmailsPage,
    showInMenu: true,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "users",
  },
  {
    id: "orders",
    path: "/orders",
    titleLocalizationKey: "pages.orders.title",
    component: OrdersPage,
    layout: AdminLayout,
    showInMenu: true,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "orders",
  },
  {
    id: "users",
    titleLocalizationKey: "pages.users.title",
    path: "/users",
    component: UsersPage,
    showInMenu: true,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "users",
  },
  {
    id: "anagManagement",
    titleLocalizationKey: "pages.anagManagement.title",
    path: "/p",
    redirectTo: "/products-management",
    showInMenu: true,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "anagManagement",
  },
  {
    id: "agencies",
    titleLocalizationKey: "pages.agencies.table_name",
    path: "/agencies",
    component: AgenciesPage,
    showInMenu: false,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "anagManagement",
  },
  // {
  //   id: "credit-providers",
  //   titleLocalizationKey: "pages.credit-providers.title",
  //   path: "/credit-providers",
  //   component: CreditProvidersPage,
  //   showInMenu: false,
  //   layout: AdminLayout,
  //   type: type.SECURED,
  //   layoutOptions: {
  //     hideOnBack: true,
  //   },
  //   section: "anagManagement",
  // },
  // {
  //   id: "families-management",
  //   titleLocalizationKey: "pages.families_management.title",
  //   path: "/families-management",
  //   component: FamiliesPage,
  //   showInMenu: false,
  //   layout: AdminLayout,
  //   type: type.SECURED,
  //   layoutOptions: {
  //     hideOnBack: true,
  //   },
  //   section: "anagManagement",
  // },
  {
    id: "families",
    titleLocalizationKey: "pages.families.table_name",
    path: "/families",
    component: FamiliesAgenciesPage,
    showInMenu: false,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "anagManagement",
  },
  {
    id: "models-management",
    titleLocalizationKey: "pages.models_management.title",
    path: "/models-management",
    component: ModelsPage,
    showInMenu: false,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "anagManagement",
  },
  {
    id: "products-management",
    titleLocalizationKey: "pages.products_management.title",
    path: "/products-management",
    component: ProductsManagementPage,
    showInMenu: false,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "anagManagement",
  },
  // {
  //   id: "services",
  //   titleLocalizationKey: "pages.services.title",
  //   path: "/services",
  //   component: ServicesPage,
  //   showInMenu: false,
  //   layout: AdminLayout,
  //   type: type.SECURED,
  //   layoutOptions: {
  //     hideOnBack: true,
  //   },
  //   section: "anagManagement",
  // },
  // {
  //   id: "product-margins",
  //   titleLocalizationKey: "pages.product_margins.title",
  //   path: "/product-margins",
  //   component: ProductMarginsPage,
  //   showInMenu: false,
  //   layout: AdminLayout,
  //   type: type.SECURED,
  //   layoutOptions: {
  //     hideOnBack: true,
  //   },
  //   section: "anagManagement",
  // },
  // {
  //   id: "product-service-costs",
  //   titleLocalizationKey: "pages.product_service_costs.title",
  //   path: "/product-service-costs",
  //   component: ProductServiceCostsPage,
  //   showInMenu: false,
  //   layout: AdminLayout,
  //   type: type.SECURED,
  //   layoutOptions: {
  //     hideOnBack: true,
  //   },
  //   section: "anagManagement",
  // },
  {
    id: "contractsDetail",
    titleLocalizationKey: "pages.contracts.title",
    path: "/contracts/:contractId",
    component: ContractsDetailPage,
    showInMenu: false,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "contracts",
  },
  {
    id: "commissions",
    titleLocalizationKey: "pages.commissions.title",
    path: "/commissions",
    component: CommissionsPage,
    showInMenu: true,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "commissions",
  },
  {
    id: "aliquoteContributive",
    titleLocalizationKey: "pages.aliquote_contributive.title",
    path: "/aliquote-contributive",
    component: AliquoteContributivePage,
    showInMenu: false,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "anagManagement",
  },
  {
    id: "regoleProvvigionali",
    titleLocalizationKey: "pages.regole_provvigionali.title",
    path: "/regole-provvigionali",
    component: RegoleProvvigionaliPage,
    showInMenu: false,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "anagManagement",
  },
  {
    id: "forbidden",
    path: "/forbidden",
    titleLocalizationKey: "pages.forbidden.title",
    component: Forbidden,
    type: type.PUBLIC,
  },
  {
    id: "importexcel",
    path: "/importexcel",
    titleLocalizationKey: "pages.import_file.title",
    component: ExcelImportPage,
    layout: AdminLayout,
    showInMenu: true,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "importexcel",
  },
  {
    id: "stats",
    path: "/stats",
    titleLocalizationKey: "pages.stats.title",
    component: StatsSelectionPage,
    layout: AdminLayout,
    showInMenu: true,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "stats",
  },
  {
    id: "stats",
    path: "/stats/:category",
    titleLocalizationKey: "pages.stats.title",
    component: TypeSelectionPage,
    layout: AdminLayout,
    showInMenu: false,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "stats",
  },
  {
    id: "stats",
    path: "/stats/:category/:id",
    titleLocalizationKey: "pages.stats.title",
    component: DataVisualizationPage,
    layout: AdminLayout,
    showInMenu: false,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "stats",
  },
  {
    id: "tickets",
    path: "/tickets",
    titleLocalizationKey: "pages.tickets.title",
    component: TicketsPage,
    layout: AdminLayout,
    showInMenu: true,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: true,
    },
    section: "tickets",
  },
  {
    id: "ticketDetail",
    titleLocalizationKey: "pages.tickets.title",
    path: "/tickets/:customerId/:productId",
    component: TicketForm,
    showInMenu: false,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "tickets",
  },
  {
    id: "estendoTicketDetail",
    titleLocalizationKey: "pages.tickets.title",
    path: "/estendotickets/:customerId/:productId",
    component: EstendoTicketForm,
    showInMenu: false,
    layout: AdminLayout,
    type: type.SECURED,
    layoutOptions: {
      hideOnBack: false,
    },
    section: "tickets",
  },
];
